export default __webpack_public_path__ + "static/silkserif-extralight-italic-d955df8505b425fac836f56f1339b3f6.woff2";